__turbopack_context__.v({
  "avatar": "values-module__9io5ZW__avatar",
  "date": "values-module__9io5ZW__date",
  "endsAfter": "values-module__9io5ZW__endsAfter",
  "figures": "values-module__9io5ZW__figures",
  "glyph": "values-module__9io5ZW__glyph",
  "glyphStates": "values-module__9io5ZW__glyphStates",
  "glyphTip": "values-module__9io5ZW__glyphTip",
  "health": "values-module__9io5ZW__health",
  "item": "values-module__9io5ZW__item",
  "missing": "values-module__9io5ZW__missing",
  "notVisible": "values-module__9io5ZW__notVisible",
  "quoted": "values-module__9io5ZW__quoted",
  "quotedProse": "values-module__9io5ZW__quotedProse",
  "sign": "values-module__9io5ZW__sign",
  "signBox": "values-module__9io5ZW__signBox",
  "signDot": "values-module__9io5ZW__signDot",
  "srOnly": "values-module__9io5ZW__srOnly",
  "stance": "values-module__9io5ZW__stance",
  "struck": "values-module__9io5ZW__struck",
  "tag": "values-module__9io5ZW__tag",
  "text": "values-module__9io5ZW__text",
  "title": "values-module__9io5ZW__title",
  "to": "values-module__9io5ZW__to",
  "value": "values-module__9io5ZW__value",
});
